<template>
      <div class="wrapper wrapper-content">
        <div class="container-fluid">


<div class="">
              
  
  
  
    
  
  
    
  


  <div class="row affiliate">
    <div class="col-lg-12">
      <div class="tabs-container">
        <ul class="nav nav-tabs">
          <li class="active">
            <router-link :to="{name: 'affiliate'}" class="no-margins text-center"><i class="fa fa-fw fa-globe"></i> ภาพรวม</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_member'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-user-circle"></i> สมาชิก</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_revenue'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-money"></i> รายได้</router-link>
          </li>
          <li style="background:#eaeaea">
            <router-link :to="{name: 'af_withdraw'}" class="no-margins text-center text-nowrap"><i class="fa fa-fw fa-bell"></i> แจ้งถอนรายได้</router-link>
          </li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane active">
              <div class="panel-body p-xs">

                <div class="row">
                  <div class="col-lg-3 col-sm-4 col-xs-6 p-xss">
                    <div class="contact-box text-center p-xss no-margins">
                      <h3>ส่วนแบ่งรายได้</h3>
                      <h1 class="text-center no-margins"><span class="text-navy">{{refer_rate}}%</span></h1>
                    </div>
                  </div>
                  <!-- <div class="col-lg-2 col-sm-4 col-xs-6 p-xss">
                    <div class="contact-box text-center p-xss no-margins">
                      <h3>จำนวนคลิกทั้งหมด</h3>
                      <h1 class="text-center no-margins"><span class="text-navy">{{ total_user }}</span></h1>
                    </div>
                  </div> -->
                  <div class="col-lg-2 col-sm-4 col-xs-6 p-xss">
                    <div class="contact-box text-center p-xss no-margins">
                      <h3>สมาชิกที่แนะนำได้</h3>
                      <h1 class="text-center no-margins"><span class="text-navy">{{ total_user }}</span></h1>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-4 col-xs-6 p-xss">
                    <div class="contact-box text-center p-xss no-margins">
                      <h3>ยอดแทงทั้งหมด</h3>
                      <h1 class="text-center no-margins"><span class="text-navy">{{ formatMoney(total_order) }}</span></h1>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-4 col-xs-6 p-xss">
                    <div class="contact-box text-center p-xss no-margins">
                      <h3>รายได้ทั้งหมด</h3>
                      <h1 class="text-center no-margins"><span class="text-navy">{{ formatMoney(total_amount) }}</span></h1>
                    </div>
                  </div>
                  <div class="col-lg-3 col-sm-4 col-xs-6 p-xss">
                    <div class="contact-box text-center p-xss no-margins">
                      <h3>รายได้จากการแนะนำ</h3>
                      <h1 class="text-center no-margins"><span class="text-navy">{{ formatMoney(affiliate_balance) }}</span></h1>
                    </div>
                  </div>
                </div>

              </div>
            </div>
        </div>
      </div>

    </div> <!-- /.col-lg-12 -->
  </div> <!-- /.row -->


  <div class="row m-t-sm">
      <div class="col-lg-12">
        <div class="ibox float-e-margins m-b-sm">
          <div class="ibox-title">
            <h5>
                ข้อความโปรโมทและลิงค์
            </h5>
          </div>
          <div class="ibox-content">
              <table class="table table-bordered table-striped table-hover">
                  <thead>
                    <tr>
                      <th class="text-center">ลิงค์สำหรับการแนะนำ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <textarea class="form-control copylink text-center" v-model="refer_link"></textarea>
                        
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th class="text-center">
                        <button v-clipboard="refer_link" v-clipboard:success="copySuccess" class="btn btn-primary block full-width m-b">คัดลอกลิงค์แนะนำ</button>
                      </th>
                    </tr>
                  </tfoot>
              </table>
          </div> <!-- /.ibox-content -->
        </div> <!-- /.ibox -->
      </div> <!-- /.col-lg-12 -->

  </div>

  <div class="row m-t-sm">
    <div class="col-lg-12">
      <div class="ibox float-e-margins m-b-sm">
        <div class="ibox-title">
          <h5>
              ลิ้งค์ช่วยแชร์ ช่วยแนะนำ
          </h5>
        </div>
        <div class="ibox-content">
          <p>ลิ้งค์ช่วยแชร์รับ {{refer_rate}}% ฟรี (แค่ก๊อปปี้ลิ้งค์ไปแชร์ก็ได้เงินแล้ว) ยิ่งแชร์มากยิ่งได้มาก</p>
          <p>ท่านสามารถนำลิ้งค์ด้านล่างนี้หรือนำป้ายแบนเนอร์ ไปแชร์ในช่องทางต่างๆ ไม่ว่าจะเป็น เว็บไชต์ส่วนตัว, Blog, Facebook หรือ Social Network อื่นๆ หากมีการสมัครสมาชิกโดยคลิกผ่านลิ้งค์ของท่านเข้ามา ลูกค้าที่สมัครเข้ามาก็จะอยู่ภายให้เครือข่ายของท่านทันที
            และหากลูกค้าภายใต้เครือข่ายของท่านมีการเดิมพันเข้ามา ทุกยอดการเดิมพัน ท่านจะได้รับส่วนแบ่งในการแนะนำ {{refer_rate}}% ทันทีโดยไม่มีเงื่อนไข</p>
          <p>ตัวอย่างเช่น...</p>
          <ul>
            <li>ลูกค้าท่าน 1 คน แทง 1,000 บาท ท่านจะได้ {{ calculateReferIncome(1000) }} บาท</li>
            <li>ลูกค้าท่าน 10 คน แทง 1,000 บาท ท่านจะได้รับ {{ calculateReferIncome(10000) }} บาท</li>
            <li>ลูกค้าท่าน 100 คน แทง 1,000 บาท ท่านจะได้รับ {{ calculateReferIncome(100000) }} บาท</li>
          </ul>
          <p>สามารถทำรายได้เดือน 100,000 บาทง่ายๆเลยทีเดียว เพราะทางเรามีหวยเปิดรับทายผลทุกวัน มีมากกว่าวันละ 200 รอบ เปิดรับแทงออนไลน์ตลอด 24 ชม. และรายได้ทุกบาททุกสตางค์ของท่านสามารถตรวจสอบได้ทุกขั้นตอน งานนี้แจกจริง จ่ายจริง
            ที่นี้ที่เดียวที่ให้คุณมากกว่าใคร ก๊อปปี้ลิ้งค์และข้อความด้านล่างนี้ นำไปแชร์ได้เลย</p>
          <p>
            <strong>หมายเหตุ:</strong>&nbsp;รายได้การช่วยแชร์ช่วยแนะนำของท่านสามารถแจ้งถอนได้ทุกเวลา หากมียอดรายได้มากกว่า 300 บาทขึ้นไป</p>
        </div> <!-- /.ibox-content -->
      </div> <!-- /.ibox -->
    </div> <!-- /.col-lg-12 -->
  </div>


            </div>


        </div>
      </div><!-- /#page-wrapper -->
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'affiliate',
    data () {
        return {
            refer_rate: 0.01,
            refer_link: '',
            total_user: 0,
            total_order: 0,
            total_amount: 0,
            total_paid_today: 0,
            total_waiting_today: 0,
            total_close_today: 0,
            affiliate_balance: 0,
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            affiliate: state => state.affiliate.affiliate,
        })
    },
    methods: {
        createReferLink () {

            if ( this.user ) {
                let baseUrl = location.origin
                this.refer_link = baseUrl + '/newregister/' + this.user.af_tokens
            }
            return this.refer_link

        },

        calculateReferIncome (total_bet) {

            let total_income =  (this.refer_rate / 100) * total_bet
            return this.formatMoney(total_income)

        },

        copySuccess ({ value, event }) {
            //console.log('success', value)
            this.$toasted.success('คัดลอกลิงค์แนะนำเรียบร้อยแล้ว.')
        },

        async getAffiliateMember () {
            try {

                //const response = 1
                const response = await this.$store.dispatch('affiliate/getAffiliate', this.user.id )
                //console.log('async initial getAffiliateMember', response)

                if ( process.env.VUE_APP_AF_RATE ) {
                    this.refer_rate = process.env.VUE_APP_AF_RATE
                }

                if ( response && response.aff_data ) {
                    this.total_user = response.total_member || 0
                    this.total_order = response.aff_data.total_data.total_amount || 0
                    this.total_amount = response.aff_data.total_data.amount || 0
                    //this.total_paid_today = response.aff_data.today_paid.amount || 0
                    this.total_close_today = response.aff_data.today_close.amount || 0

                    this.refer_rate = response.refer_rate
                }

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
                //this.$router.push({name: 'login',})
            }
        },

        async getAffiliateLedger () {
            try {

                const response = await this.$store.dispatch('affiliate/getAffiliateLedger', this.user.af_account_id )
                //console.log('async initial getAffiliateLedger', response)

                if ( response ) {
                    this.affiliate_balance = response.balance
                }

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
                //this.$router.push({name: 'login',})
            }
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

    },
    created () {
        //console.log('crypto')
        this.createReferLink()
        this.getAffiliateMember()
        this.getAffiliateLedger()
    },
    destroyed () {
    },
    mounted () {
    },
}
</script>

<style lang="sass" scoped>
</style>
